import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as topojson from 'topojson-client';
import { GeoJSON, withLeaflet } from 'react-leaflet';

function mergeTopojsonByKey(topoJsonData, filterFunc) {
  const key = Object.keys(topoJsonData.objects)[0];
  const topoJsonObject = topoJsonData.objects[key];

  return topojson.merge(
    topoJsonData,
    topoJsonObject.geometries.filter(d => filterFunc(d.properties))
  );
}

class Overlay extends PureComponent {
  static propTypes = {
    fill: PropTypes.bool,
    fillColor: PropTypes.string,
    weight: PropTypes.number,
    color: PropTypes.string,
    opacity: PropTypes.number,
    data: PropTypes.object,
    smoothFactor: PropTypes.number
  }

  static defaultProps = {
    fill: false,
    fillColor: '#eee',
    weight: 1,
    color: '#999',
    opacity: 1,
    data: null,
    smoothFactor: 0.5
  }

  render() {
    if (!this.props.data || !this.props.isFiltered) {
      return null;
    }

    return (
      <GeoJSON
        key={`overlay_${+this.props.isFiltered}`}
        data={this.props.data}
        fill={this.props.fill}
        fillColor={this.props.fillColor}
        weight={this.props.weight}
        color={this.props.color}
        opacity={this.props.opacity}
        smoothFactor={this.props.smoothFactor}
        className={this.props.className}
      />
    );
  }
}

export default withLeaflet(Overlay);
